<template>
  <div class="container mt-5">
    <div class="row animatedCircle text-center justify-content-center">
      <div
        v-for="(circle, index) in circles"
        :key="index"
        class="animatedCircle__each"
      >
        <div class="circle-wrapper">
          <CircleProgress
            :percent="circle.label === 'Maximum Speed' ? 100 : circle.current.value"
            :stroke-width="14"
            :size="160"
            :color="circle.label === 'Maximum Speed' ? '#3498db' : dynamicColor(circle.current.value)"
            empty-color="#eef1f5"
            :animation="true"
            :animation-duration="2500"
            :rounded="true"
          />
<div class="circle-text">
  {{ circle.label === 'Maximum Speed' ? '10GB' : Math.round(circle.current.value) + '%' }}
</div>

        </div>
        <h3 class="blue mt-2">{{ circle.label }}</h3>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAnimatedProgressProvider } from '@/composables/AnimatedProgressProvider';
import { easeQuadInOut } from 'd3-ease';
import CircleProgress from 'vue3-circle-progress';

const rawCircles = [
  { label: 'Dedicated Line', target: 99, maxValue: 100 },
  { label: 'Business Broadband', target: 95, maxValue: 100 },
  { label: 'Wireless Connect', target: 99, maxValue: 100 },
  { label: 'Average Service Level', target: 99, maxValue: 100 },
  { label: 'Maximum Speed', target: 10, maxValue: 100 },
];

const circles = ref(
  rawCircles.map((circle) => ({
    ...circle,
    current: useAnimatedProgressProvider({
      valueStart: 0,
      valueEnd: circle.target,
      duration: 2500,
      easingFunction: easeQuadInOut,
      repeat: false,
    }),
  }))
);

const dynamicColor = (val) => {
  const hue = (val * 1.2 + 120) % 360;
  return `hsl(${hue}, 80%, 50%)`;
};
</script>

<style scoped>
.animatedCircle {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap; 
  padding: 1rem 0;
}

.animatedCircle__each {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px;
  height: 200px;
  margin: 0.5rem;
  position: relative;
}

.circle-wrapper {
  position: relative;
  width: 160px;
  height: 160px;
}

.circle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

.blue {
  color: #3498db;
}

@media (max-width: 768px) {
  .animatedCircle__each {
    width: 150px;
    height: 180px;
    margin: 1rem 0;
  }

  .circle-wrapper {
    width: 150px;
    height: 150px;
  }
}
</style>
